import { useEffect, useState } from 'react';
import { sendMyaPatchRequest } from 'modules/hub/components/AMAChat/AskMeAnything/Conversation/sendMyaPatchRequest';
export const useMoreQuestions = ({ delay = 1000, messages, inputPopulated, sessionToken, conversationId, onClickMoreQuestions, }) => {
    const [showMoreQuestions, setShowMoreQuestions] = useState(false);
    const [showCsat, setShowCsat] = useState(false);
    useEffect(() => {
        if (inputPopulated) {
            setShowMoreQuestions(false);
        }
    }, [inputPopulated]);
    useEffect(() => {
        if (inputPopulated)
            return;
        if (showCsat)
            return;
        const timeout = setTimeout(() => {
            setShowMoreQuestions(true);
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [messages, inputPopulated, showCsat]);
    const handleMoreQuestionsClick = async ({ moreQuestions, messageId, }) => {
        setShowMoreQuestions(false);
        if (!moreQuestions) {
            if (onClickMoreQuestions)
                onClickMoreQuestions(false);
            setShowCsat(true);
        }
        if (messageId) {
            await sendMyaPatchRequest({
                conversationId,
                body: {
                    misc_payload: { moreQuestions: moreQuestions ? 'yes' : 'no' },
                },
                messageId,
                sessionToken,
            });
        }
    };
    return {
        handleMoreQuestionsClick,
        showMoreQuestions,
        showCsat,
    };
};
